import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { curationsApiPath } from './apiPath';

const PutCurationOrderRequestSchema = z.object({
  type: z.enum(['GOODS', 'SNAP2']).optional(),
  curationIds: z.array(z.union([z.number(), z.string()])),
});

const PutCurationOrderResponseDataSchema = z.object({
  curations: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      type: z.string().optional(),
      ordNo: z.number(),
    }),
  ),
});

type PutCurationOrderRequest = z.infer<typeof PutCurationOrderRequestSchema>;

type PutCurationOrderResponseData = z.infer<typeof PutCurationOrderResponseDataSchema>;
type PutCurationOrderResponse = MusinsaStandardResponse<PutCurationOrderResponseData>;

export const putCurationOrder = (request: PutCurationOrderRequest) =>
  executeStandardRequest(async () =>
    privateHttpClient.put<PutCurationOrderResponse>(curationsApiPath.putCurationsOrder, {
      ...(request.type ? { type: request.type } : {}),
      curationIds: request.curationIds.map((id) => String(id)),
    }),
  );
